<template>
	<div class="main">
		<div :class="
						this.error === null
							? 'inputs'
							: 'inputs-error'
					">
			<div>
				<input
					v-mask="'#####-###'"
					type="text"
					name="zipcode"
					v-model="zipcode"
					:class="
						this.error === null
							? 'zipcode-input'
							: 'zipcode-input-error'
					"
					placeholder="Insira o CEP"
				/>

				<p class="error-text" v-if="this.error != null">
					{{ this.error }}
				</p>
			</div>

			<button @click="addZipCode" class="add-address">
				<img src="../../assets/icone-plus.svg" alt="" />
				Adicionar endereço
			</button>
		</div>

		<div class="list-zipcodes">
			<div v-for="item in listZipcodes" :key="item" class="zipcode-item">
				<img src="../../assets/icone-lugar.svg" alt="" />
				<p class="list-zipcode-text">CEP</p>
				<p>{{ item }}</p>
			</div>
		</div>

		<div class="generate-address">
			<div class="generate-address-button">
				<button @click="this.generateAddress" class="add-address">
					Gerar endereço
				</button>
			</div>

			<div class="divider"></div>

			<section v-if="this.isSuccess">
				<div
					class="list-address"
					v-for="item in this.addressList"
					:key="item.id"
				>
					<AddressCard @remove="remove" :address="item" />
				</div>
			</section>
		</div>
	</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mask } from "vue-the-mask";
import AddressCard from "../AddressCard";

export default {
	directives: { mask },
	components: {
		AddressCard,
	},
	data() {
		return {
			zipcode: "",
			listZipcodes: [],
			addressList: [],
			isSuccess: false,
			error: null,
		};
	},
	methods: {
		remove(id) {
			const code = this.addressList.find((el) => el.id === id);
			this.listZipcodes = this.listZipcodes.filter(
				(el) => el !== code.data.cep
			);
			this.generateAddress();
		},
		generateAddress() {
			this.addressList = [];
			for (let i = 0; i < this.listZipcodes.length; i++) {
				this.$viaCep.buscarCep(this.listZipcodes[i]).then((obj) => {
					this.addressList.push({
						id: i + 1,
						data: obj,
					});
				});
			}
			this.isSuccess = true;
		},
		addZipCode() {
			this.error = null;
			let list = this.listZipcodes.find((el) => el === this.zipcode);
			if (this.zipcode !== "") {
        if (!list) {
          this.listZipcodes.push(this.zipcode);
          this.error = null;
					this.zipcode = "";
				} else {
					this.error =
						"Você não pode adicionar esse CEP, pois ele já existe na sua lista !";
					this.zipcode = "";
				}
			} else {
				this.error =
					"Certifique-se de preencher o campo !";
			}
		},
	},
};
</script>

<style>
@import url("./style.scss");
</style>
